import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes) },
    { path: 'views', loadChildren: () => import('./views/views.routes').then(m => m.viewsRoutes) },
];
